var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity_details_index"},[_c('div',{staticClass:"pt40"},[_c(_vm.activeCom,{tag:"components"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }